import script from "./WorkKpi.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkKpi.vue?vue&type=script&setup=true&lang=js"

import "./WorkKpi.vue?vue&type=style&index=0&id=6a04dfad&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a04dfad"]])

export default __exports__